import { useEffect } from "react";
import { isTokenExist } from "utils/cookies";
import { useDispatch, useSelector } from "react-redux";
import store from "store";
import _ from "lodash";

import {
  setApp,
  setConfig,
  setMenu,
  setOption,
  setLoadedInit,
  setPermissions,
} from "redux/configSlice";
import { setReference } from "redux/referenceSlice";
import { userSelector, loadedInitSelector } from "redux/selectors";
import { useInits } from "queries/inits";

// Digunakan untuk handle mengisi return endpoint dari init ke state redux
const useLoadInits = (skipCheckEndpoint = false) => {
  const dispatch = useDispatch();
  const tokenExist = isTokenExist();
  const user = useSelector(userSelector);
  const loadedInit = useSelector(loadedInitSelector);
  const checkEndpoint = skipCheckEndpoint ? true : !!store.get("app.endpoint");
  const enabled = tokenExist && !user?.id && !loadedInit && checkEndpoint;
  const { data } = useInits({
    enabled,
  });

  // Set redux from inits
  useEffect(() => {
    if (data?.user && enabled) {
      const websiteId = parseInt(data.website_id, 10);
      const roles = data?.user?.app_roles || ["admin"];
      const currentRole = store.get("app.role");
      const findRole = roles.includes("admin") ? "admin" : roles[0];
      const livestream = data?.livestream || {};
      const livestreamWithThumbnail = {
        ...livestream,
        is_show_thumbnail: true,
      };
      if (!currentRole) {
        store.set("app.role", findRole);
      }
      store.set("app.settings.locale", data.user?.lang);
      dispatch(
        setConfig({
          locale: data.user?.lang,
          endpoint: data.endpoint,
          selectedCompany: { website_id: websiteId, endpoint: data.endpoint },
          role: currentRole ? currentRole : findRole,
        })
      );
      dispatch(
        setApp({
          user: data.user,
          lang: data.lang,
          billing: data.billing,
          translation: data.translation,
          companies: data.companies || [],
          website_id: websiteId,
          setting: data.setting,
          dashboard: data.dashboard,
          gajihubStartDate: data?.gajihub_start_date,
          employeeCountAvailable: data?.employee_count_available || [],
          defaultMinEmployeeOrder: data?.default_min_employee_order || 0,
          maxCompanies: data?.max_companies || 0,
          showNps: data?.show_nps || 0,
          showQueueCount: data?.show_hr_queue_count || 0,
          announcement: data?.announcement || "",
          eventCalendars: data?.event_calendars || [],
          banner: data?.banner || [],
          livestream: livestreamWithThumbnail || {},
          alerts: data?.alerts || [],
        })
      );
      dispatch(setOption(data.option));
      dispatch(setReference(data.reference));
      dispatch(setLoadedInit(true));
      dispatch(
        setMenu(
          currentRole === "employee" && !_.isEmpty(data?.user?.menus_employee)
            ? data?.user?.menus_employee
            : data?.user?.menus
        )
      );
      dispatch(
        setPermissions(
          currentRole === "employee" &&
            !_.isEmpty(data?.user?.permissions_employee)
            ? data?.user?.permissions_employee
            : data?.user?.permissions
        )
      );
    }
  }, [data, dispatch, enabled]);
};

export default useLoadInits;
